import { useSelector, useDispatch } from "react-redux";
import LoyaltyOptInModal from "../../components/LoyaltyOptInModal";
import {
  getLoyaltyIsOptedIn,
  getLoyaltyIsInvited,
  getLoyaltyIsEnabled
} from "../../state/modules/config/selectors";
import {
  analyticsLoyaltyOptInClick,
  analyticsLoyaltyOptInReject
} from "../../state/modules/analytics/actions";

import { getCategoryId } from "../../state/modules/category";
import { loyaltyOptIn } from "../../state/modules/config/actions";

const ConnectedLoyaltyOptInModal = props => {
  const loyaltyIsInvited = useSelector(getLoyaltyIsInvited);
  const loyaltyIsOptedIn = useSelector(getLoyaltyIsOptedIn);
  const categoryId = useSelector(getCategoryId);
  const loyaltyIsEnabled = useSelector(getLoyaltyIsEnabled);
  const dispatch = useDispatch();

  return (
    <LoyaltyOptInModal
      {...props}
      categoryId={categoryId}
      loyaltyIsEnabled={loyaltyIsEnabled}
      loyaltyIsInvited={loyaltyIsInvited}
      loyaltyIsOptedIn={loyaltyIsOptedIn}
      loyaltyOptIn={() => dispatch(loyaltyOptIn())}
      analyticsLoyaltyOptInClick={() => dispatch(analyticsLoyaltyOptInClick())}
      analyticsLoyaltyOptInReject={() =>
        dispatch(analyticsLoyaltyOptInReject())
      }
    />
  );
};

export default ConnectedLoyaltyOptInModal;
